import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
import loadConfig from "@Web3WalletConfig/config";
export default {
  name: "luckylottryitemscustem",
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", 'setting'])
  },
  data() {
    return {
      loadConfig,
      isLock: false,
      list: {},
      popTaskShow: false,
      modifyData: {
        "icon": ""
      },
      isLoading: false,
      lotteryid: 0,
      selectTab: 0
    };
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let rs = await this.$http.post("/luckylottery/logic", {
        lottery_id: this.lotteryid,
        status: this.selectTab == 0 ? 1 : 0
      });
      this.isLoading = false;
      if (rs.code == 0) {
        this.list = rs.data.logic_list;
        let item_list = rs.data.item_list;
        let item_list_arr = [];
        item_list.map(item => {
          item_list_arr['i_' + item.id] = item;
        });
        this.list.map((item, index) => {
          if (item.reward_options && JSON.parse(item.reward_options)) {
            item.reward_options = JSON.parse(item.reward_options);
          }
          if (item.show_options && JSON.parse(item.show_options)) {
            item.show_options = JSON.parse(item.show_options);
          }
          if (!item.items) {
            item.items = [];
          }
          if (item.reward_options) {
            item.reward_options.map((it, idx) => {
              item.items.push(item_list_arr['i_' + it]);
            });
          }
          // if(item.show_options){
          //   item.show_options.map((it,idx)=>{
          //     if(!item.reward_options.includes(it)){
          //       let _it = JSON.parse(JSON.stringify(item_list_arr['i_'+it]))
          //       _it.onlyShow = true
          //       item.items.push(_it)
          //     }
          //   })
          // }
        });
      }
    },
    async onCreate() {
      this.modifyData = {
        "lottery_id": this.lotteryid,
        items: []
      };
      this.popTaskShow = true;
    },
    async onModify(item) {
      this.modifyData = item;
      this.popTaskShow = true;
    },
    cutStr(str) {
      if (str) return str.replace("T", " ").replace(".000Z", "");
    },
    onRefresh() {
      this.getData();
    },
    onLogs(id) {
      this.$router.push("/luckylotterylogs?item_id=" + id);
    }
  },
  mounted() {
    this.lotteryid = this.$route.query.id || 0;
    if (!this.lotteryid) {
      this.$router.back();
    }
    this.getData();
  }
};